import { useEffect, useState } from 'react'
import { Table, Space, Button, Col, Row, Divider, Input, Pagination } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { DATE_TIME_FORMAT_CLIENT, getPage, PAGE_SIZE } from '../../helpers/constants'
import { useTranslation } from 'react-i18next'
import Create from './Create'
import Detail from './Detail'
import moment from 'moment'
import useWindowDimensions from '../../common/useWindowDimensions'
import useModal from 'src/helpers/modal/useModal'
import { isEmpty, trim } from 'lodash'
import { formatCurrency } from 'src/helpers/functions'

const ServiceManagement = observer(() => {
   const { t } = useTranslation()
   const ServiceStore = useStore('ServiceStore')
   const [textSearch, set_textSearch] = useState('')
   const { height } = useWindowDimensions()

   const [visibleCreate, setVisibleCreate] = useState(false)
   const [visibleDetail, setVisibleDetail] = useState(false)
   const [item, setItem] = useState<any>(null)
   const { confirm } = useModal()
   const { rows, offset, count } = ServiceStore.serviceList

   useEffect(() => {
      getListData(0, { name: trim(textSearch) })
   }, [textSearch])

   const getListData = async (currentPage: number, param?: any) => {
      try {
         const offset = getPage(currentPage)
         const params = { offset, ...param }
         ServiceStore.getServiceList(params)
      } catch (error) {}
   }

   const onChange = (currentPage: number) => {
      getListData(currentPage - 1, { name: trim(textSearch) })
   }

   const handleChangeTextSearch = (value: any) => {
      set_textSearch(value)
   }

   const showCreate = () => {
      setVisibleCreate(true)
   }

   const handleDelete = (value: any) => {
      confirm({
         title: 'Bạn muốn xoá dịch vụ này?',
         icon: <ExclamationCircleOutlined />,
         okText: 'Đồng ý',
         cancelText: 'Huỷ',
         onCancel() {},
         async onOk() {
            await ServiceStore.deleteService(value?.id)
            getListData(0)
         }
      })
   }

   const handleCreate = async () => {
      getListData(0)
      setVisibleCreate(false)
   }

   const handleCancel = () => {
      setVisibleCreate(false)
   }

   const handleEdit = () => {
      getListData(0)
      setVisibleDetail(false)
      setItem(null)
   }

   const hideDetail = () => {
      setVisibleDetail(false)
      setItem(null)
   }

   const showDetail = (value: any) => {
      setItem(JSON.parse(JSON.stringify(value)))
      setTimeout(() => {
         setVisibleDetail(true)
      }, 300)
   }

   const columns = [
      {
         title: 'ID',
         dataIndex: 'id',
         key: 'id',
         align: 'center' as 'center',
         width: 60
      },
      {
         title: 'Tên dịch vụ',
         dataIndex: 'name',
         key: 'name',
         width: 200,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'Giá',
         dataIndex: 'price',
         key: 'price',
         width: 120,
         render: (value: any) => {
            return <span>{formatCurrency(value)}</span>
         }
      },
      {
         title: 'Hiển thị cho',
         dataIndex: 'visibleTo',
         key: 'visibleTo',
         width: 150,
         render: (value: any) => {
            if (!value || value.length === 0) return <span>Tất cả</span>
            return <span>{value.length} người dùng</span>
         }
      },
      {
         title: 'Ngày tạo',
         dataIndex: 'createdAt',
         key: 'createdAt',
         width: 120,
         render: (value: string) => {
            return <span>{moment(value).format(DATE_TIME_FORMAT_CLIENT)}</span>
         }
      },
      {
         title: 'Thao tác',
         key: 'action',
         width: 120,
         align: 'center' as 'center',
         fixed: 'right' as 'right',
         render: (text: string, record: any) => {
            return (
               <span>
                  <span onClick={() => showDetail(record)} className="gx-link">
                     Sửa
                  </span>
                  <Divider type="vertical" />
                  <span onClick={() => handleDelete(record)} className="gx-link">
                     Xoá
                  </span>
               </span>
            )
         }
      }
   ]

   const renderPagination = () => {
      if (isEmpty(rows)) return null
      return (
         <div className="containerPagination">
            <Pagination
               onChange={onChange}
               pageSize={PAGE_SIZE}
               current={offset / PAGE_SIZE + 1}
               showSizeChanger={false}
               total={count}
            />
         </div>
      )
   }

   return (
      <>
         <Row>
            <Col span={24}>
               <Row className="row-container-head">
                  <Col xs={24} md={12}>
                     <Input.Search onSearch={handleChangeTextSearch} placeholder="Tìm kiếm dịch vụ" allowClear />
                  </Col>
                  <Col xs={24} md={12}>
                     <div className="text-right">
                        <Space>
                           <Button type="primary" className="btn-add" onClick={showCreate}>
                              <i className="icon icon-add icon-in-button" />
                              Tạo dịch vụ
                           </Button>
                        </Space>
                     </div>
                  </Col>
               </Row>

               <Space className="total-items">Tổng: {count}</Space>

               <Table scroll={{ y: height - 200 }} columns={columns} dataSource={rows} rowKey="id" pagination={false} />

               {renderPagination()}
            </Col>
         </Row>
         {visibleCreate && <Create visible={visibleCreate} onOk={handleCreate} onCancel={handleCancel} />}
         {visibleDetail && item && (
            <Detail visible={visibleDetail} item={item} onOk={handleEdit} onCancel={hideDetail} />
         )}
      </>
   )
})

export default ServiceManagement
